<template>
  <div id="container">
    <div id="left" class="column"></div>
    <div id="center" class="column">
      <div style="padding: 20px; text-align: center">
        <el-button type="goon" @click="onThree">下载</el-button>
      </div>
      <div id="pdfDom">
        <div class="header-all" style="height: 1421.42px">
          <div class="tui-reportHeader">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-6/2022-6-23/20220623135937_1734.png?x-oss-process=style/imgset"
              style="width: 12rem; height: 100%"
              alt=""
              crossOrigin="anonymous"
            />
            <div
              style="
                position: absolute;
                top: -20px;
                left: 0;
                right: 0;
                text-align: center;
              "
            >
              <div class="TenanName">{{ userInfo.SchoolName }}</div>
              <div class="tui-reportTitle">膳食营养分析报告</div>
            </div>
          </div>
          <div class="header-all-title">
            <div style="font-size: 25px; color: #fff; padding-bottom: 20px">
              记录人：{{ reportInfo.Reporter || "蘑菇宝宝" }}
            </div>
            <div style="font-size: 25px; color: #fff">
              {{ reportInfo.ReportDate }}
            </div>
          </div>
        </div>
        <!-- <div class="pdf-item">
          <div class="header-all-title">
            <div class="tui-headerTitle" style="">
              {{ reportInfo.SchoolName }}膳食营养分析报告
            </div>
            <div class="tui-headerName">
              记录人：{{ reportInfo.Reporter || "蘑菇宝宝" }}
            </div>
            <div
              style="
                font-size: 31px;
                font-weight: bold;
                color: #333;
                padding-top: 30px;
              "
            >
              {{ reportInfo.ReportDate }}
            </div>
          </div>
        </div> -->
        <!-- 表格 -->
        <div
          style="
            width: 100%;
            height: 1421px;
            overflow: hidden;
            background: #f0fafd;
          "
        >
          <div
            style="
              width: 90%;
              margin: 20px auto;
              border-radius: 20px;
              background: #fff;
            "
          >
            <div style="font-size: 64px; font-weight: 500; text-align: center">
              膳食营养分析报告
            </div>
            <div style="width: 90%; margin: 20px auto">
              <div class="flex">
                <div class="tui-colorNum">
                  本月总人数：{{ reportInfo.AllPeople }}
                </div>
                <div class="tui-colorNum" style="padding-left: 40px">
                  本月总人日数：{{ reportInfo.DayPeople }}
                </div>
              </div>
              <div class="tui-colorNum" style="padding-top: 20px">
                本月食材（不含调味品）：{{ reportInfo.AllFoodLib }}种
              </div>
            </div>
            <el-table
              :data="reportInfo.FoodReportDetails"
              stripe
              :header-cell-style="{
                'text-align': 'center',
                color: '#333',
              }"
              style="width: 90%; margin: 0 auto"
              border
            >
              <el-table-column prop="Name" label="食材类" align="center">
              </el-table-column>
              <el-table-column
                prop="Recommend"
                label="推荐摄入量(g)"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="Actual"
                label="实际摄入量(g)"
                align="center"
              >
              </el-table-column>
              <el-table-column label="结果" align="center">
                <template slot-scope="scope">
                  <div
                    :style="{
                      color: scope.row.Result == '偏低' ? '#E14747' : '',
                    }"
                  >
                    {{ scope.row.Result }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div
          style="
            width: 100%;
            height: 1421px;
            overflow: hidden;
            background: #f0fafd;
          "
        >
          <div
            style="
              width: 90%;
              margin: 20px auto;
              border-radius: 20px;
              background: #fff;
            "
          >
            <el-table
              :data="reportInfo.NutritionReportDetails"
              stripe
              border
              :header-cell-style="{
                'text-align': 'center',
                color: '#333',
              }"
              style="width: 90%; margin: 0 auto"
            >
              <el-table-column prop="Name" label="营养成份" align="center">
              </el-table-column>
              <el-table-column
                prop="Recommend"
                label="推荐占供给量范围"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="Actual"
                label="实际占供给量%"
                align="center"
              >
              </el-table-column>
              <el-table-column label="结果" align="center">
                <template slot-scope="scope">
                  <div
                    :style="{
                      color: scope.row.Result == '偏低' ? '#E14747' : '',
                    }"
                  >
                    {{ scope.row.Result }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 封底 -->
        <div
          style="
            width: 100%;
            height: 1421px;
            overflow: hidden;
            background: #f0fafd;
          "
          class="flex-center"
        >
          <img
            src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-6/2022-6-29/20220629140448_1357.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div id="right" class="column"></div>
  </div>
</template>
<script>
import { GetFoodReportInfo } from "../../../api/api";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
  data() {
    return {
      userInfo: {},
      reportInfo: {},
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetFoodReportInfo();
  },
  methods: {
    onThree: function (event) {
      this.isShow = false;
      const loading = this.$loading({
        lock: true,
        text: "正在下载PDF",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let that = this;
      setTimeout(() => {
        let top = document.getElementById("pdfDom");
        if (top != null) {
          top.scrollIntoView();
          top = null;
        }
        var content = document.querySelector("#pdfDom");
        html2Canvas(content, {
          useCORS: true,
          scale: 1, // 提升画面质量，但是会增加文件大小
        }).then((canvas) => {
          var contentWidth = canvas.width;
          var contentHeight = canvas.height; //一页pdf显示html页面生成的canvas高度;
          var pageHeight = (contentWidth / 592.28) * 841.89; //未生成pdf的html页面高度
          //console.log(pageHeight);
          var leftHeight = contentHeight; //页面偏移
          var position = 0; //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          var imgWidth = 595.28;
          var imgHeight = (592.28 / contentWidth) * contentHeight;

          var pageData = canvas.toDataURL("image/jpeg", 1.0);

          var pdf = new JsPDF("", "pt", "a4"); //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89) //当内容未超过pdf一页显示的范围，无需分页

          if (leftHeight < pageHeight) {
            pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            // 分页
            while (leftHeight > 0) {
              pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89; //避免添加空白页
              if (leftHeight > 0) {
                pdf.addPage();
              }
            }
          }
          pdf.save(`${this.reportInfo.Reporter}膳食营养分析报告.pdf`);
          loading.close();
        });
      }, 300);
    },
    async GetFoodReportInfo() {
      const params = {
        StartDate: this.$route.query.StartDate,
        EndDate: this.$route.query.EndDate,
        SchoolId: this.userInfo.SchoolId,
      };
      let res = await GetFoodReportInfo(params);
      if (res.data.success) {
        this.reportInfo = res.data.response;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tui-colorNum {
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #32c5ff;
}
.header-all {
  height: 100%;
  background: url(../../../assets/newBG.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  .tui-reportHeader {
    width: 100%;
    margin: 0 auto;
    position: absolute;
    top: 190px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .TenanName {
      font-size: 40px;
      color: #fff;
    }
    .tui-reportTitle {
      font-size: 60px;
      color: #fff;
      padding-top: 20px;
    }
    .tui-class {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 20px;

      span {
        width: 0.225rem;
        height: 0.225rem;
        border-radius: 50%;
        background: #ffec8e;
      }
      div {
        font-size: 0.375rem;
        color: #ffec8e;
        font-weight: 600;
        letter-spacing: 0.0625rem;
        padding: 0 0.25rem;
      }
    }
  }
  .header-Name {
    text-align: center;
    text-shadow: 0px 6px 1px #fff;
    font-size: 70px;
    font-family: Lantinghei SC;
    font-weight: 800;
    color: #3ec53f;
    padding-top: 111px;
  }
  .tui-headerName {
    font-size: 73px;
    font-weight: bold;
    text-align: center;
    color: #32c5ff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 60px;
  }
  .tui-headerTitle {
    width: 717px;
    height: 184px;
    font-size: 84px;
    font-weight: bold;
    text-align: center;
    color: #32c5ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header-all-title {
    position: absolute;
    bottom: 43px;
    left: 0;
    right: 0;

    display: flex;
    align-items: center;
    flex-direction: column;
  }
}
.pdf-item {
  width: 100%;
  height: 1421px;
  background: url(../../../assets/baogao-bg.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  .header-Name {
    text-align: center;
    text-shadow: 0px 6px 1px #fff;
    font-size: 70px;
    font-family: Lantinghei SC;
    font-weight: 800;
    color: #3ec53f;
    padding-top: 111px;
  }
  .tui-headerName {
    font-size: 64px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    font-weight: bold;
    text-align: center;
    color: #32c5ff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 479px;
  }
  .tui-headerTitle {
    width: 912px;
    height: 210px;
    font-size: 82px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    letter-spacing: 7px;
    text-align: center;
    color: #32c5ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header-all-title {
    padding-top: 232px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
}
.el-button--goon {
  color: #fff;
  background-color: #32c5ff;
  border-color: #32c5ff;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
#container {
  display: flex;
}
#container .column {
  height: 100%;
  /* line-height: 300px; */
}
#center {
  width: 1000px;
  background: #fff;
}
#left {
  flex: 1;
}
#right {
  flex: 1;
}
</style>